<script setup lang="ts"></script>

<template>
  <icon name="lucide:circle-check" />
</template>

<style scoped></style>
